// @ts-nocheck


import { useWallet } from "@solana/wallet-adapter-react";
import { LAMPORTS_PER_SOL } from "@solana/web3.js";
import { createContext, useContext, useEffect, useState, useMemo } from "react";

const anchor = require("@project-serum/anchor");


const BalanceContext = createContext(null);


let envRpcHost="https://api.devnet.solana.com"

const rpcHost = envRpcHost!;
const connection = new anchor.web3.Connection(rpcHost);

export default function useWalletBalance() {
  const { balance, walletPubKey, walletAddress }: any =
    useContext(BalanceContext);
  return { balance, walletPubKey, walletAddress };
}

export const WalletBalanceProvider: React.FC<{}> = ({ children }) => {
  const wallet = useWallet();
  const [balance, setBalance] = useState(0);
  const [walletPubKey, setWalletPubKey] = useState({});
  const [walletAddress, setWalletAddress] = useState("");

  const anchorWallet = useMemo(() => {
    if (
      !wallet ||
      !wallet.publicKey ||
      !wallet.signAllTransactions ||
      !wallet.signTransaction
    ) {
      return;
    }

    return {
      publicKey: wallet.publicKey,
      signAllTransactions: wallet.signAllTransactions,
      signTransaction: wallet.signTransaction,
    } as anchor.Wallet;
  }, [wallet]);

  const refreshWallet = async () => {
    if (!anchorWallet) {
      setBalance(0);
      setWalletAddress("");
      setWalletPubKey({});
      return;
    }

    try {
      const balance = await connection.getBalance(anchorWallet.publicKey);
      setBalance(balance / LAMPORTS_PER_SOL);
      setWalletPubKey(anchorWallet.publicKey);
      setWalletAddress(anchorWallet.publicKey.toBase58());
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    refreshWallet();
  }, [anchorWallet, balance, walletAddress]);

  return (
    <BalanceContext.Provider
      value={{ balance, walletPubKey, walletAddress } as any}
    >
      {children}
    </BalanceContext.Provider>
  );
};
